module.exports = __webpack_public_path__ + "static/media/visa.dd1410d7.svg";